import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { SETTINGS_INJECTION_TOKENS } from '@tourfold/shared-kernels/settings-registry';
import { AuditLog } from './settings-audit-log.component';
import { ResourceAccessGuard } from '@tourfold/shared-kernels/resource-access';

export function provideSettingsElementAuditLogSettings(): EnvironmentProviders {
  return makeEnvironmentProviders([
    {
      provide: SETTINGS_INJECTION_TOKENS,
      useValue: {
        path: 'audit-log',
        name: 'Audit Log',
        icon: 'pi pi-history',
        component: AuditLog,
        order: 2,
        translateName: 'SETTINGS_AUDIT_LOG.AUDIT_LOG',
        resource_key: 'auditLog',
        required_action: 'read',
        planLockedBehavior: 'upsell',
        entitlementFeatureKey: 'audit-log',
        canActivate: [ResourceAccessGuard],
        category: {
          id: 'other',
          name: 'Other',
          order: 3,
          translateName: 'SETTINGS.CATEGORIES.OTHER',
        },
      },
      multi: true,
    },
  ]);
}
